import { useState } from 'react';

import DropdownArrowIcon from '@/assets/all-icons/dropdown-arrow-icon';
import { useDropdownPopover } from '@/shared-components/dropdown';

export default function DropdownFormMultipleChoices({ element, selectOptions, readOnly, placeholder, fillWith }) {
  const [selectedOptions, setOptions] = useState(fillWith ? fillWith : selectOptions.defaultOption ? [selectOptions.defaultOption] : []);
  const [isOpen, setIsOpen] = useState(false);
  const {
    rootRef,
    triggerRef,
    menuId,
    toggle,
    handleTriggerKeyDown,
  } = useDropdownPopover({
    open: isOpen,
    onOpenChange: setIsOpen,
    disabled: readOnly,
    idPrefix: element || 'dropdown-form-multiple-choices',
  });

  function isSelected(option) {
    return selectedOptions.includes(option);
  }

  function removeOption(option) {
    setOptions(selectedOptions.filter(item => item !== option));
  }

  return (
    <>
      <div
        className={`dropdown dropdown--form dropdown-form-multiple-choices__container ${readOnly ? "read-only" : ""} ${isOpen ? "is-open" : ""}`}
        id={`${element}_error`}
        ref={(node) => {
          rootRef.current = node;
          triggerRef.current = node;
        }}
      >
        <div
          tabIndex={readOnly ? -1 : 0}
          role="combobox"
          aria-haspopup="listbox"
          aria-expanded={isOpen}
          aria-controls={menuId}
          onClick={toggle}
          onKeyDown={handleTriggerKeyDown}
        >
          <label htmlFor={element} className="dropdown__label dropdown-form-multiple-choices__label"> {placeholder} </label>
          <div className="dropdown__trigger dropdown__value-row dropdown-form-multiple-choices__selected-options-container">
            <input type="text" className="dropdown__value dropdown-form-multiple-choices__selected-options" value={selectedOptions.join(", ")} id={element} name={element} readOnly={true} />
            <div className="dropdown-form-multiple-choices__open-options-container">
              {!readOnly && <DropdownArrowIcon className="dropdown__indicator dropdown-form-multiple-choices__open-options" />}
            </div>
          </div>
        </div>
                
        <div id={menuId} className="dropdown__menu dropdown-form-multiple-choices__options-container" role="listbox" aria-multiselectable="true">
          {selectOptions.options.map((option, index) => {
            if(isSelected(option)) {
              return <p className="dropdown__option dropdown-form-multiple-choices__option selected" role="option" aria-selected="true" onMouseDown={()=>removeOption(option)} key={index}>{option}</p>;
            }
            return <p className="dropdown__option dropdown-form-multiple-choices__option" role="option" aria-selected="false" onMouseDown={()=>setOptions([...selectedOptions, option])} key={index}>{option}</p>;
          })}
        </div>
      </div>
    </>
  );
}
